import React from "react";
import { ReserveFormOfficeSelector } from "@/features/reserve/components/Reserve/controls/ReserveFormOfficeSelector";
import { ReserveFormFloorSelector } from "@/features/reserve/components/Reserve/controls/ReserveFormFloorSelector";
import { useReserveForm } from "@/features/reserve/components/Reserve/ReserveFormProvider";

export const ReserveFormFloor = () => {
  const { floors } = useReserveForm();
  const isFloorSelectorEnabled = (floors?.length ?? 0) > 1;

  return (
    <div className="grid grid-cols-2 gap-x-2">
      <div className={isFloorSelectorEnabled ? "col-span-1" : "col-span-2"}>
        <ReserveFormOfficeSelector className="grow border-0 bg-neutral-50" />
      </div>
      {isFloorSelectorEnabled ? (
        <div className="col-span-1">
          <ReserveFormFloorSelector className="grow border-0 bg-neutral-50" />
        </div>
      ) : null}
    </div>
  );
};
